/* eslint-disable no-unused-vars */
enum ConversationUserType {
  UP_USER = 'UP_USER',
  DBG_USER = 'DBG_USER',
}

export default ConversationUserType;
